import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-text-main-inversion bg-brand-400 flex gap-1 rounded-[40px] p-[3px] pl-2 text-xs font-medium',
    icon: 'h-5 w-5'
  }
});
